import { sagaEffects } from '../../dependencies';

import connectionStatus from './connectionStatus';

const { all } = sagaEffects;

export default function*() {
    yield all([connectionStatus()]);
}
